module.exports = __webpack_public_path__ + "static/media/zain-logo.20a29a3f.svg";